import { render, staticRenderFns } from "./FAQInvitationInfo.vue?vue&type=template&id=5466f15a&scoped=true"
import script from "./FAQInvitationInfo.vue?vue&type=script&lang=js"
export * from "./FAQInvitationInfo.vue?vue&type=script&lang=js"
import style0 from "./FAQInvitationInfo.vue?vue&type=style&index=0&id=5466f15a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466f15a",
  null
  
)

export default component.exports